import { services } from '@broadleaf/admin-components';
import ContractPriceCheckTool from 'app/utility/ContractPriceCheckTool';

const { ComponentRegistrar } = services;

// Must match ContractPriceCheckView.TYPE in the metadata service
ComponentRegistrar.registerViewComponent(
  'AURORA_CONTRACT_PRICE_CHECK',
  ContractPriceCheckTool
);
